import { CircularProgress } from 'library/loaders';
import { FC } from 'react';

interface PagePreloaderProps {}

const PagePreloader: FC<PagePreloaderProps> = (props) => {
    return (
        <div className="fixed top-0 left-0 flex items-center justify-center h-screen w-full bg-card-color text-primary">
            <CircularProgress />
        </div>
    );
};

export default PagePreloader;
